'use client';

import { useLogout, useWallets } from '@privy-io/react-auth';
import { EVMContextProvider } from '@vertex-protocol/react-client';
import { ComponentProps, useCallback } from 'react';
import { useDisconnect } from 'wagmi';
import { useRegisterAppManagedWalletConnector } from 'client/modules/app/appData/useRegisterAppManagedWalletConnector';

type Props = ComponentProps<typeof EVMContextProvider>;

export function PrivyAwareEVMContextProvider(props: Props) {
  useRegisterAppManagedWalletConnector();

  const { logout } = useLogout();
  const { wallets } = useWallets();
  const { disconnect: disconnectWagmi } = useDisconnect();

  const disconnectOverride = useCallback(() => {
    wallets.forEach((wallet) => {
      wallet.disconnect();
    });
    disconnectWagmi();
    void logout();
  }, [disconnectWagmi, logout, wallets]);

  return (
    <EVMContextProvider {...props} disconnectOverride={disconnectOverride} />
  );
}
